import { getNames as getCountries, registerLocale } from 'i18n-iso-countries';
import deCountries from 'i18n-iso-countries/langs/de.json';
import enCountries from 'i18n-iso-countries/langs/en.json';
import { Language } from '../types/enums/language.enum';
// TODO important - add country locales on new language
registerLocale(deCountries);
registerLocale(enCountries);

export const getCountryNames = (lang: Language) => Object.values(getCountries(lang)).flat();
